/* ============================================================
   WowSticker — cart store (mock of Shopify's cart)
   ------------------------------------------------------------
   A tiny localStorage-backed cart that mirrors Shopify's line-item
   shape (properties, quantity, price in cents). On theme export,
   swap the read/write internals for Shopify's AJAX Cart API:
     add    → POST /cart/add.js      { id, quantity, properties }
     setQty → POST /cart/change.js   { id|line, quantity }
     remove → POST /cart/change.js   { id|line, quantity: 0 }
     items  → GET  /cart.js          → cart.items
   The item.properties object here is exactly what becomes Shopify
   line-item properties; keys starting with "_" stay hidden in cart.
   ============================================================ */
(function(){
  'use strict';
  var KEY = 'wowCart';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY) || '[]'); }catch(e){ return []; } }
  function write(items){
    try{ localStorage.setItem(KEY, JSON.stringify(items)); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('wowcart:change')); }catch(e){}
  }
  function uid(){ return 'w' + Date.now().toString(36) + Math.random().toString(36).slice(2,6); }

  var WowCart = {
    items: read,
    count: function(){ return read().reduce(function(n,i){ return n + (i.quantity||1); }, 0); },
    subtotal: function(){ return read().reduce(function(s,i){ return s + (i.price||0) * (i.quantity||1); }, 0); },
    add: function(item){ var it=read(); item.key = item.key || uid(); item.quantity = item.quantity || 1; it.push(item); write(it); return item.key; },
    setQty: function(key,q){ var it=read(); it.forEach(function(i){ if(i.key===key) i.quantity = Math.max(1, q|0); }); write(it); },
    remove: function(key){ write(read().filter(function(i){ return i.key!==key; })); },
    clear: function(){ write([]); }
  };

  // keep every page's header cart badge in sync
  function refreshBadges(){
    var n = WowCart.count();
    document.querySelectorAll('.cart-count').forEach(function(el){
      el.textContent = n;
      el.classList.toggle('empty', n===0);
    });
  }
  document.addEventListener('wowcart:change', refreshBadges);
  window.addEventListener('storage', function(e){ if(e.key===KEY) refreshBadges(); });
  document.addEventListener('DOMContentLoaded', refreshBadges);
  if(document.readyState!=='loading') refreshBadges();

  window.WowCart = WowCart;
})();
